var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.17157 0 1.5 0.671573 1.5 1.5V13.5C1.5 14.3284 2.17157 15 3 15H12C12.8284 15 13.5 14.3284 13.5 13.5V4.06066C13.5 3.66284 13.342 3.28131 13.0607 3L10.5 0.43934C10.2187 0.158035 9.83716 0 9.43934 0H3ZM4.125 6C3.91789 6 3.75 6.16789 3.75 6.375C3.75 6.58211 3.91789 6.75 4.125 6.75H10.875C11.0821 6.75 11.25 6.58211 11.25 6.375C11.25 6.16789 11.0821 6 10.875 6H4.125ZM3.75 8.625C3.75 8.41789 3.91789 8.25 4.125 8.25H10.875C11.0821 8.25 11.25 8.41789 11.25 8.625C11.25 8.83211 11.0821 9 10.875 9H4.125C3.91789 9 3.75 8.83211 3.75 8.625ZM4.125 10.5C3.91789 10.5 3.75 10.6679 3.75 10.875C3.75 11.0821 3.91789 11.25 4.125 11.25H8.625C8.83211 11.25 9 11.0821 9 10.875C9 10.6679 8.83211 10.5 8.625 10.5H4.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.11d6644347d3223546a314e096972589.svg";
export { ForwardRef as ReactComponent };